import { gql } from '@apollo/client'

import { FRAGMENT as STUDENT_WORK_FRAGMENT } from 'src/components/StudentWorkCard'

export const PAGES = gql`
  query HallOfFamer_pages {
    hallOfFamers(perPage: 200) {
      nodes {
        id
        slug
      }
    }
  }
`

export default gql`
  query HallOfFamer($slug: String!) {
    hallOfFamer(slug: $slug) {
      id
      title
      slug
      image {
        url
        blurhash
      }
      type
      url
      users {
        id
        name
        username
        avatar {
          url
        }
      }

      next {
        ...StudentWorkCardComponent
        next {
          ...StudentWorkCardComponent
        }
      }

      previous {
        ...StudentWorkCardComponent
        previous {
          ...StudentWorkCardComponent
        }
      }
    }
  }

  ${STUDENT_WORK_FRAGMENT}
`
